import $store from '@/store';

export default class AgentVoiceLogoffEvent {
  constructor() {
    $store.dispatch('channel/setDisconnectVoiceChannel');
    $store.dispatch('_connection/setConnectionWebRTCStatus', 'disconnected');
  }
}
